import { Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Loading from 'components/Loading';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import ClientsTemplate from '../Templates/Clients';
import ClientSecureDeviceValidation from '../Configurations/ClientSecureDeviceValidation';
import { ClientFields } from 'modules/clients/interfaces';

interface SecurityClientsProps {
  client: ClientFields | null;
  isLoading: boolean;
}

const SecurityClients = ({ client, isLoading }: SecurityClientsProps) => {
  const enabled =
    client?.environment?.device_validation_settings
      ?.device_validation_enabled === true;

  return (
    <ClientsTemplate
      current="security"
      title={i18n.t('CLIENTS_PAGE.SECURITY_TAB_KEY')}
      breadcrumbs={[
        { name: i18n.t('CLIENTS_KEY'), link: '/clients' },
        { name: i18n.t('CLIENTS_PAGE.SECURITY_TAB_KEY') },
      ]}
    >
      {isLoading || !client ? (
        <Loading />
      ) : enabled ? (
        <ClientSecureDeviceValidation client={client} />
      ) : (
        <Alert severity="info">
          <Typography variant="body2">
            {i18n.t('SECURE_DEVICE_VALIDATION_AT_ENVIRONMENT_KEY')}
          </Typography>
        </Alert>
      )}
    </ClientsTemplate>
  );
};

const mapStateToProps = ({
  clients: { clientSelected, isLoading },
}: ApplicationState) => ({
  client: clientSelected,
  isLoading,
});

export default connect(mapStateToProps, {})(SecurityClients);
